import {
  AdvancedImage,
  lazyload,
  placeholder,
  responsive,
} from '@cloudinary/react';
import { myCld } from '../../utils/constants';
import type { GalleryImage } from '../../models/GalleryImage';
import { Link, useParams } from 'react-router';
import hercsHead from '../../images/Hercules_head_cropped_300px.png';
import { useQuery } from '@tanstack/react-query';
import PublicProfileApi from '../../apis/publicProfileApi';
import AppLayout from '../../components/AppLayout';
import ShowPending from '../../components/ShowPending';

export default function PublicGalleryPage() {
  const { id } = useParams();
  const { data: publicGallery, isPending } = useQuery({
    queryKey: ['publicGallery', id],
    queryFn: () => PublicProfileApi.getPublicGallery(id!),
    enabled: !!id,
  });

  return (
    <AppLayout>
      <div className='w-full'>
        <ShowPending isPending={isPending} />
        {Array.isArray(publicGallery) ? (
          <div className='mt-4 grid w-full grid-cols-[repeat(auto-fit,_minmax(300px,_1fr))] justify-center gap-4'>
            {publicGallery.map((g: GalleryImage) => (
              <div
                key={g.alpacaImageId}
                className='image-overlay relative flex justify-center'
              >
                <AdvancedImage
                  className='align-self-center max-h-[200px] justify-self-center rounded'
                  cldImg={myCld.image(g.imageName)}
                  plugins={[lazyload(), responsive(), placeholder()]}
                />
                <div className='image-title'>
                  {<span className='dark:text-gray-600'>{g.name}</span>}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className='flex flex-col items-center justify-center'>
            <h2 className='text-center'>Nothing to see here!</h2>
            <Link to={`/`} className='text-center'>
              Return to Home Page
            </Link>
            <div className='mt-4'>
              <img src={hercsHead} alt='Hercules' />
            </div>
          </div>
        )}
      </div>
    </AppLayout>
  );
}
